import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'app/config/store';
import { Table, Row, Col, Tag, Spin, Space, Button, Form, Select } from 'antd';
import { RouteComponentProps, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { getSession } from 'app/shared/reducers/authentication';
import { JhiItemCount, JhiPagination, getSortState, TextFormat } from 'react-jhipster';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { getAllVirements } from './virement.reducer';
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';

const virementDashboard = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();
  const allVirements = useAppSelector(state => state.virement.entities);
  const totalItems = useAppSelector(state => state.virement.totalItems);
  const loading = useAppSelector(state => state.virement.loading);
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );
  useEffect(() => {
    dispatch(getSession());
    sortEntities();
  }, [paginationState.activePage, paginationState.itemsPerPage]);

  const handlePagination = (currentPage: number) => {
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
  };

  const virementList = () => {
    const entity = {
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getAllVirements(entity));
  };

  const sortEntities = () => {
    virementList();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}`);
    }
  };

  const renderOptionValided = id => {
    return (
      <Space size="middle">
        <Button type="primary" style={{ height: 30, width: 45 }}>
          <Link to={`/virements/demande/${id}/details`}>
            <FontAwesomeIcon icon="eye" />{' '}
          </Link>
        </Button>
      </Space>
    );
  };
  const renderOptionOnProcess = id => {
    return (
      <Space size="middle">
        <Link to={`/virements/demande/${id}/validation`}>
          <Button style={{ backgroundColor: 'green', color: 'white' }}>Valider</Button>
        </Link>
      </Space>
    );
  };

  const column = [
    {
      title: 'Date et Heure',
      dataIndex: 'date',
      key: 'date',
      align: 'center' as const,
      render: date => <TextFormat type="date" value={date} format={APP_TIMESTAMP_FORMAT} />,
    },
    {
      title: 'Etablissements',
      dataIndex: 'ecole',
      key: 'ecole',
      align: 'center' as const,
    },
    {
      title: 'Montants',
      dataIndex: 'montant',
      key: 'montant',
      align: 'center' as const,
    },
    {
      title: 'Statuts',
      dataIndex: 'statut',
      key: 'statut',
      align: 'center' as const,
      render: statut =>
        statut === 'ENCOURS' ? (
          <Tag color="red">En attente</Tag>
        ) : statut === 'VALIDE' ? (
          <Tag color="green">Validée</Tag>
        ) : (
          <Tag color="#999">{statut}</Tag>
        ),
    },
    {
      title: 'Options',
      dataIndex: ['id', 'statut'],
      key: 'id',
      align: 'center' as const,
      render: (text, row) =>
        row['statut'] === 'ENCOURS' ? renderOptionOnProcess(row['id']) : row['statut'] === 'VALIDE' ? renderOptionValided(row['id']) : '',
    },
  ];

  const dataSource = allVirements.map((virement, i) => ({
    id: virement.id,
    date: virement.dateEmission,
    description: virement.description,
    ecole: virement.ecole ? virement.ecole.nom : '',
    montant: virement.montant + ' FCFA',
    statut: virement.statutVirement,
  }));

  const onSearch = vals => {};

  const handleChange = () => {};

  return (
    <div>
      <h2 className="center"> Demandes des Virements</h2>
      <Form name="basic" layout="inline" onFinish={onSearch}>
        <Row className="p-1">
          <Col span={20} sm={20} md={20} xs={17} xxl={20} xl={20} lg={24}>
            <Form.Item name="statutFacture">
              <Select placeholder="Status" allowClear onClear={handleChange}>
                <Select.Option value="ENCOURS">
                  <Tag color="red">En attente</Tag>
                </Select.Option>
                <Select.Option value="VALIDEE">
                  <Tag color="green">Validée</Tag>
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={1} sm={1} md={1} xs={1} xxl={1} xl={1} lg={3}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                <FontAwesomeIcon icon={faSearch} />
              </Button>
            </Form.Item>
          </Col>
        </Row>

        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Table columns={column} dataSource={dataSource} bordered pagination={false} style={{ textAlign: 'center' }} />
          </Spin>
        </div>
        {totalItems ? (
          <div className={allVirements && allVirements.length > 0 ? 'table-responsive' : 'd-none'}>
            <Row className="justify-content-center">
              <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
            </Row>
            <Row className="justify-content-center">
              <JhiPagination
                activePage={paginationState.activePage}
                onSelect={handlePagination}
                maxButtons={5}
                itemsPerPage={paginationState.itemsPerPage}
                totalItems={totalItems}
              />
            </Row>
          </div>
        ) : (
          ''
        )}
      </Form>
    </div>
  );
};
export default virementDashboard;
